import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { UntypedFormArray } from '@angular/forms';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'beneficiary-clause-form',
    templateUrl: './beneficiary-clause-form.component.html',
    styleUrls: ['./beneficiary-clause-form.component.scss'],
    standalone: false
})
export class BeneficiaryClauseFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    const pledge = this.subscriptionFacade.getPledge();
    const product = pledge?.products?.[0];
    const isCorumSubscription = product?.parameters?.partnerFlux === 'CORUM';
    const parameters = this.form.get('products')?.get('0')?.get('parameters');

    if (
      !isCorumSubscription ||
      (isCorumSubscription &&
        parameters?.get('avClauseBeneficiaire')?.value !== 'LIBRE')
    ) {
      const avClauseBeneficiaires = this.form
        .get('products')
        ?.get('0')
        ?.get('parameters')
        ?.get('avClauseBeneficiaireBeneficiaires') as UntypedFormArray;
      while (avClauseBeneficiaires.length !== 0) {
        avClauseBeneficiaires.removeAt(0);
      }
      avClauseBeneficiaires.setValidators([]);
      avClauseBeneficiaires.updateValueAndValidity();
    }

    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
